import React, { useState, useEffect } from "react";
import axiosInstance from "../../axiosConfig";
import AddTenantModal from "./AddTenantModal";
import "./TenantManager.scss";
import ModifyTenantModal from "./ModifyTenantModal";
import { toast } from "react-toastify";

const TenantManager = () => {
  const [tenants, setTenants] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showModifyModal, setShowModifyModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredTenants, setFilteredTenants] = useState([]);
  const [isUpgrading, setIsUpgrading] = useState(false);
  const [isUpgradingEmailAutomation, setIsUpgradingEmailAutomation] =
    useState(false);

  // Fetching tenant details
  useEffect(() => {
    const fetchTenantDetails = async () => {
      try {
        const response = await axiosInstance.get("/tenants/details");
        if (response.data.status === 200) {
          setTenants(response.data.data);
          setFilteredTenants(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching tenant details:", error);
      }
    };

    fetchTenantDetails();

    const fetchModules = async () => {
      try {
      } catch (error) {
        console.error("Error fetching modules:", error);
      }
    };
    fetchModules();
  }, []);

  // Filter tenants based on the search query
  useEffect(() => {
    if (searchQuery === "") {
      setFilteredTenants(tenants);
    } else {
      setFilteredTenants(
        tenants.filter(
          (tenant) =>
            tenant.companyName
              .toLowerCase()
              .includes(searchQuery.toLowerCase()) ||
            tenant.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
            tenant.modulesSelected.some((module) =>
              module.toLowerCase().includes(searchQuery.toLowerCase()),
            ),
        ),
      );
    }
  }, [searchQuery, tenants]);

  // Handle schema upgrade for all tenants
  const handleSchemaUpgrade = async () => {
    if (
      window.confirm(
        "Are you sure you want to upgrade the schema for all tenants? This operation cannot be undone.",
      )
    ) {
      setIsUpgrading(true);
      try {
        const response = await axiosInstance.post(
          "/migration/schema/upgrade/all/tenant",
        );

        if (response.data) {
          toast.success(
            "Schema upgrade initiated successfully for all tenants!",
          );
        }
      } catch (error) {
        console.error("Error upgrading schema:", error);
        toast.error("Failed to upgrade schema. Please try again.");
      } finally {
        setIsUpgrading(false);
      }
    }
  };

  const handleEmailAutomationUpgrade = async () => {
    if (
      window.confirm(
        "Are you sure you want to upgrade email automation for all tenants?",
      )
    ) {
      setIsUpgradingEmailAutomation(true);

      try {
        const response = await axiosInstance.post(
          `${process.env.REACT_APP_BACKEND_URL}/migration/data/upgrade/all/tenant`,
        );

        if (response.data) {
          toast.success(
            "Email automation upgrade initiated successfully for all tenants!",
          );
        }
      } catch (error) {
        console.error("Error upgrading email automation:", error);
        toast.error("Failed to upgrade email automation. Please try again.");
      } finally {
        setIsUpgradingEmailAutomation(false);
      }
    }
  };

  return (
    <div className="tenant-manager">
      <div className="tenant-actions">
        <button
          onClick={() => {
            setShowAddModal(true);
          }}
        >
          Add Company
        </button>

        <button
          onClick={() => {
            setShowModifyModal(true);
          }}
        >
          Edit Company
        </button>

        <button
          onClick={handleSchemaUpgrade}
          disabled={isUpgrading}
          className="upgrade-schema-btn"
        >
          {isUpgrading ? "Upgrading..." : "Upgrade Schema"}
        </button>

        <button
          onClick={handleEmailAutomationUpgrade}
          disabled={isUpgradingEmailAutomation}
          className="upgrade-email-automation-btn"
        >
          {isUpgradingEmailAutomation
            ? "Upgrading..."
            : "Upgrade Email Automation"}
        </button>

        <input
          type="text"
          className="search"
          placeholder="Search tenants by company name, email or modules"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <table>
        <thead>
          <tr>
            <th>Company Name</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Modules Purchased</th>
            <th>Expiry Date</th>
          </tr>
        </thead>
        <tbody>
          {filteredTenants.map((tenant, index) => (
            <tr key={index}>
              <td>{tenant.companyName}</td>
              <td>{tenant.email}</td>
              <td>{tenant.phoneNumber}</td>
              <td>{tenant.modulesSelected.join(", ")}</td>
              <td>{tenant.expiryDate}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <AddTenantModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        axiosInstance={axiosInstance}
      />

      <ModifyTenantModal
        isOpen={showModifyModal}
        onClose={() => setShowModifyModal(false)}
        axiosInstance={axiosInstance}
      />
    </div>
  );
};

export default TenantManager;
